import {nomeMeses} from "@/helpers";

const opcoes = {
  chart: {
    id: "chart-rupturas",
    type: "area",
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    toolbar: {
      show: false
    },
    zoom: {
      enabled: false
    },
    stacked: false,
  },
  grid: {
    show: true,
    position: "back",
    yaxis: {
      lines: {
        show: true
      }
    },
    xaxis: {
      lines: {
        show: true
      }
    }
  },
  noData: {
    text: "Carregando... aguarde",
    align: "center",
    verticalAlign: "middle",
    style: {
      fontSize: "14px"
    }
  },
  stroke: {
    width: 2
  },
  markers: {
    size: 3,
    strokeWidth: 1.2,
    hover: {
      size: 7
    }
  },
  labels: [0,0,0,0,0,0,0,0,0,0,0,0,0],
  dataLabels: {
    enabled: false,
    offsetY: -5,
    distributed: true,
    style: {
      fontSize: "11px",
      fontWeight: false,
      colors: ["#000"]
    },
    background: {
      enabled: false
    },
    formatter: function(val) {
      return formatter(val, 1);
    }
  },
  yaxis: {
    show: true,
    forceNiceScale: true,
    title: {
      text: "Perda Vendas por Ruptura",
      style: {
        color: "#000",
        fontSize: "12px",
        fontWeight: 600,
        cssClass: "apexcharts-yaxis-title"
      }
    },
    labels: {
      formatter: function(val) {
        return formatter(val, 0);
      }
    }
  },
  xaxis: {
    labels: {
      minWidth: 50,
      maxWidth: 50,
      formatter: referencia => {
        if (!`${referencia}`.includes('/')) return 'Mês';

        const [mes] = `${referencia}`.split('/');
        return (nomeMeses[parseInt(mes) - 1] || ' ').substring(0, 3);
      }
    }
  },
  fill: {
    gradient: {
      type: "vertical",
      opacityFrom: 1,
      opacityTo: .8,
      stops: [10, 50, 100]
    }
  },
  legend: {
    position: 'top',
    offsetY: 5,
    markers: {
      width: 13,
      height: 13,
      radius: 1
    },
    itemMargin: {
      horizontal: 10,
      vertical: 0
    }
  }
};

function formatter(n, casasDecimais = 2) {
  var ranges = [
    { divider: 1e6, suffix: "M" },
    { divider: 1e3, suffix: "k" },
    { divider: 1, suffix: " " }
  ];

  for (var i = 0; i < ranges.length; i++) {
    if (n >= ranges[i].divider) {
      if (ranges[i].divider === 1) {
        return (
          (Math.round(n) / ranges[i].divider).toString() + ranges[i].suffix
        );
      } else {
        return (
          (Math.round(n) / ranges[i].divider)
            .toFixed(casasDecimais)
            .toString() + ranges[i].suffix
        );
      }
    }
  }
  return 0;
}

export { opcoes };
